import { render } from "./JamesonCellCalculator.vue?vue&type=template&id=12e41e5d&ts=true"
import script from "./JamesonCellCalculator.vue?vue&type=script&lang=ts"
export * from "./JamesonCellCalculator.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@5.5.4__webpack@5.97.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__